// extracted by mini-css-extract-plugin
export var actions = "_4h-0";
export var actionsContainer = "_4h-6";
export var border = "_4h-1";
export var childFullHeight = "_4h-d";
export var collapse = "_4h-2";
export var content = "_4h-8";
export var contentChild = "_4h-c";
export var fullscreen = "_4h-a";
export var headerContainer = "_4h-3";
export var headerRow = "_4h-5";
export var hidePadding = "_4h-9";
export var noScrollX = "_4h-e";
export var noScrollY = "_4h-f";
export var optOutTopPadding = "_4h-b";
export var pagePadding = "_4h-7";
export var profile = "_4h-g";
export var profileContainer = "_4h-h";
export var profileImage = "_4h-i";
export var profileMain = "_4h-j";
export var profileSubtitle = "_4h-l";
export var profileTitle = "_4h-k";
export var tabsWrapper = "_4h-4";
export var title = "_4h-m";